import { useEffect, useState } from "react";
import { whenFree } from "@/lib/popupQueue";
import { Crown, PartyPopper, Check } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { confetti, playFanfare, floatEmojis } from "@/lib/celebrate";

const KEY = "itz_seen_jackpots";
const seen = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const busy = () => document.querySelector('[role="dialog"],[data-testid="lucky-wheel-modal"],[data-testid="level-up-modal"],[data-testid="scratch-big-celebration"]');

export function JackpotCelebration() {
  const { user } = useAuth();
  const [jp, setJp] = useState(null);
  const [sent, setSent] = useState(false);
  useEffect(() => {
    if (!user) return;
    const check = () => {
      if (document.visibilityState !== "visible" || busy()) return;
      api.get("/wheel/jackpot-latest").then(({ data }) => {
        if (!data || seen().includes(data.id)) return;
        whenFree(`jackpot-${data.id}`, () => {
          localStorage.setItem(KEY, JSON.stringify([...seen(), data.id].slice(-20)));
          setJp(data); setSent(false);
          playFanfare();
          [0, 500, 1100, 1800].forEach((d, i) => setTimeout(() => confetti({ x: innerWidth * (0.2 + 0.3 * (i % 3)), y: innerHeight * 0.35, count: 90, spread: 1.6 }), d));
          setTimeout(() => setJp((cur) => (cur?.id === data.id && !cur.hold ? null : cur)), 9000);
        });
      }).catch(() => {});
    };
    const t = setTimeout(check, 3000);
    const iv = setInterval(check, 15000);
    return () => { clearTimeout(t); clearInterval(iv); };
  }, [user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!jp) return null;
  return (
    <div className="fixed inset-0 z-[88] flex items-center justify-center p-6 bg-slate-950/60 backdrop-blur-sm wheel-fade" onClick={() => setJp(null)} data-testid="jackpot-celebration" style={{ pointerEvents: "auto" }}>
      <div className="relative text-center text-white levelup-pop">
        <span className="burst-rays !-inset-28" aria-hidden />
        <p className="text-xs font-extrabold uppercase tracking-[0.35em] text-amber-300">Live in der Community</p>
        <div className="relative mx-auto mt-10 w-32 h-32">
          {jp.picture ? <img src={jp.picture} alt={jp.name} className="w-32 h-32 rounded-full object-cover levelup-medal" />
            : <div className="w-32 h-32 rounded-full bg-gradient-to-br from-amber-300 to-pink-500 flex items-center justify-center font-display text-5xl font-black levelup-medal">{jp.name?.[0]?.toUpperCase()}</div>}
          <Crown className="absolute -top-7 left-1/2 -translate-x-1/2 w-14 h-14 text-amber-400 fill-amber-400 drop-shadow-lg" />
        </div>
        <h2 className="font-display text-5xl font-black mt-5 jackpot-title" data-testid="jackpot-celebration-title">JACKPOT!</h2>
        <p className="mt-2 text-lg font-bold max-w-xs mx-auto" data-testid="jackpot-celebration-text">{jp.text}</p>
        <button type="button" disabled={sent} data-testid="jackpot-congrats-btn"
          onClick={(e) => { e.stopPropagation(); floatEmojis(e.currentTarget, "🎉", 10); setSent(true); setJp((c) => ({ ...c, hold: true })); api.post(`/wheel/jackpot/${jp.id}/congrats`).catch(() => {}); setTimeout(() => setJp(null), 1800); }}
          className="mt-5 inline-flex items-center gap-2 px-7 h-12 rounded-full bg-gradient-to-r from-amber-300 to-orange-400 text-amber-950 font-extrabold shadow-lg shadow-amber-500/30 active:scale-95 transition-transform disabled:opacity-90">
          {sent ? <><Check className="w-5 h-5" /> Glückwunsch gesendet!</> : <><PartyPopper className="w-5 h-5" /> Gratulieren</>}
        </button>
        <p className="mt-3 text-sm text-white/70">Dreh heute auch am Glücksrad – vielleicht bist du der Nächste! 🎡</p>
      </div>
    </div>
  );
}
